
$(function() {
    
    if($('body').hasClass('template-index')){
        //top slider
        $('.mainvisual_slider').slick({
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear'
        });
        //top slider
        $(window).on('load',function(){
            $('#shopify-section-16048922206f41b10b').appendTo('.top-content');
            $('#shopify-section-16048922206f41b10b').prepend('<h2>INSTAGRAM</h2>');
        });
    }
    // gloval navigation 
	$('#menuButton').on('click', function() {
		if($(this).hasClass('is-active')){
			$(this).removeClass('is-active');
            $('.sitemap').removeClass('is-active');
		} else {
			$(this).addClass('is-active');
            $('.sitemap').addClass('is-active');
		}
	});
    // search 
	$('.header_wrap_icn .r-iconList .search').on('click', function() {
        $('.searchMdl').addClass('is-active');
	});
    $('.searchMdl_inner_box .searchClose').on('click', function() {
        $('.searchMdl').removeClass('is-active');
    });
    // sp pc switch
    var replaceWidth = 768;
    (function () {
        var $setElem = $('.switch'),
            pcName   = '_pc',
            spName   = '_sp';

        $setElem.each(function () {
            var $this = $(this);
            function imgSize() {
                var winWidth = window.innerWidth;
                if (winWidth != 'undefind') {
                    if (winWidth <= replaceWidth) {
                        $this.attr('src', $this.attr('src').replace(pcName, spName));
                    } else {
                        $this.attr('src', $this.attr('src').replace(spName, pcName));
                    }
                }
            }
            $(window)
                .on('resize', function () {
                    imgSize();
                });
            imgSize();
        });
    })();
    // product
    if($('body').hasClass('template-product')){
        // product accodion
        $('.infobox .ttl').on('click', function() {
            if($(this).hasClass('is-active')){
                $(this).removeClass('is-active');
                $(this).next().slideUp();
            } else {
                $(this).addClass('is-active');
                $(this).next().slideDown();
            }
        });
        // form
        $('.product-contact').on('click', function() {
            $('.single-form').removeClass('hide');
        });
        $('.single-form-modal .closeBtn').on('click', function() {
            $('.single-form').addClass('hide');
        });
        var producturl = location.href;
        $('#ContactFormUrl').val(producturl);
        
        if($('.form-success').length){
            $('.note.form-success').prependTo('.product-single');
        }
        var position = $(".product-single__image-wrapper").offset().top;
        $('.thumbnails').on('click', function() {
            $("html,body").animate({
                scrollTop : position - 110
            }, {
                queue : false
            });
        });
    }
  // cart
  $('input[type="number"]').focusout(function() {
        if(typeof $(this).attr('min') !== "undefined" && parseInt($(this).val()) < parseInt($(this).attr('min')))
            $(this).val($(this).attr('min'));
        else if(typeof $(this).attr('max') !== "undefined" && parseInt($(this).val()) > parseInt($(this).attr('max')))
            $(this).val($(this).attr('max'));
        else if(typeof $(this).attr('min') !== "undefined" && $(this).val() === '')
            $(this).val($(this).attr('min'));
    });

  // cart coming soonボタン無効
    setTimeout(function(){
        if($('.template-product').length && $('button:contains("Coming Soon..")').length){
            $('#AddToCart').css('display','none');
        }
    },500); 
    setTimeout(function(){
        if($('.template-product').length && $('button:contains("Coming Soon..")').length){
            $('#AddToCart').css('display','none');
        }
    },1000);  
    setTimeout(function(){
        if($('.template-product').length && $('button:contains("Coming Soon..")').length){
            $('#AddToCart').remove();
        }
    },1500);
});